export var configuration = function configuration(siteApi) {
  return {
    get: function get(key) {
      return siteApi.get('/configuration', {
        params: {
          key: key
        }
      });
    }
  };
};